import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AltaForm from './components/AltaForm';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import PagosDashboard from './components/PagosDashboard';
import GrupoView from './components/GrupoView';
import UsuariosManager from './components/UsuariosManager';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100 flex flex-col">
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<AltaForm />} />
            <Route path="/alta" element={<AltaForm />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/dashboard" element={<AdminDashboard />} />
            <Route path="/pagos" element={<PagosDashboard />} />
            <Route path="/grupo" element={<GrupoView />} />
            <Route path="/usuarios" element={<UsuariosManager />} />
          </Routes>
        </div>
        <footer className="bg-blue-600 text-white py-4 text-center">
          <p className="text-sm">
            Hecho con ❤️ por <strong>Impulsa Telecom S.L</strong> - "Apoyamos el deporte"
          </p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
